// @ts-nocheck
import translate from "@insite/client-framework/Translate";
import { CompanyLocation } from "@store/Framework/Store/Bunzl/Pages/Reporting/LoadLocations";
import { locationsSelector } from "@store/Framework/Store/Bunzl/Pages/Reporting/ReportOrderFrequency/ReportOrderFrequencySelectors";
import useGetShipToAndBillTo from "@store/Framework/Store/Data/Accounts/Hooks/useGetShipToAndBillTo";
import { getCustomerLocationDisplayName } from "@store/Library/Components/Reporting/LocationPicker/LocationPicker";
import useLocation from "@store/Library/Components/Reporting/LocationPicker/useLocation";
import ModalPicker from "@store/Library/Components/Reporting/ModalPicker/ModalPicker";
import invert from "lodash/invert";
import React from "react";
import { useSelector } from "react-redux";

interface ShipToPickerProps {
    isError?: boolean;
}

const getCustomerIdByNameDictionary = (locations: CompanyLocation[]) => {
    return locations.reduce((acc: { [key: string]: string }, companyLocation) => {
        companyLocation.customers.forEach(customerLocation => {
            acc[getCustomerLocationDisplayName(customerLocation)] = customerLocation.id;
        });
        return acc;
    }, {});
};

const ReportingShipToPicker: React.FC<ShipToPickerProps> = ({ isError = false }) => {
    const locations = useSelector(locationsSelector);
    const { toggleItem, toggleAllCompanyCustomers, selectedItems } = useLocation();
    const currentBillTo = useGetShipToAndBillTo().billTo;
    const currentCompany = locations?.find(companyLocation => companyLocation?.id === currentBillTo?.id);
    const companyCustomerNames =
        currentCompany?.customers.map(customerLocation => getCustomerLocationDisplayName(customerLocation)) || [];
    const companyIdsByName = getCustomerIdByNameDictionary(locations || []);

    const companyNamesById = invert(companyIdsByName);

    const getSelectedItemNames = () => {
        return selectedItems.map(selectedItem => companyNamesById[selectedItem]);
    };
    const handleItemToggle = (item: string) => {
        toggleItem(companyIdsByName[item]);
    };

    return (
        <ModalPicker
            error={isError}
            data={companyCustomerNames}
            selectedItems={getSelectedItemNames()}
            header={translate("Locations")}
            toggleAllItems={() => toggleAllCompanyCustomers(currentCompany?.customers || [])}
            toggleItem={handleItemToggle}
        />
    );
};

export default ReportingShipToPicker;
